function getLicensePlateColor(state) {
    let fontColor, fontColor2, licensePlateColor;
  
    switch (state) {
      case "":
        licensePlateColor = "#00000000"; // Transparent
        fontColor = "#FFFFFF";
        fontColor2 = "#FFFFFF";
        break;
  
      case "AK":
        licensePlateColor = "#EFBD15";
        fontColor = "#071C46";
        fontColor2 = "#071C46";
        break;
  
      case "AL":
        licensePlateColor = "#6EAAAA";
        fontColor = "#060805";
        fontColor2 = "#060805";
        break;
  
      case "AR":
        licensePlateColor = "#B9FFFF";
        fontColor = "#020805";
        fontColor2 = "#781030";
        break;
  
      case "AZ":
        licensePlateColor = "#57C1B4";
        fontColor = "#0E2B1A";
        fontColor2 = "#503354";
        break;
  
      case "CA":
        licensePlateColor = "#000000";
        fontColor = "#FFFF00";
        fontColor2 = "#FFFF00";
        break;
  
      case "CO":
        licensePlateColor = "#1B403A";
        fontColor = "#FFFFFF";
        fontColor2 = "#FFFFFF";
        break;
  
      case "CT":
        licensePlateColor = "#3683D5";
        fontColor = "#0D1E4C";
        fontColor2 = "#FFFFFF";
        break;
  
      case "DC":
        licensePlateColor = "#FFFFFF";
        fontColor = "#D70000";
        fontColor2 = "#06203D";
        break;
  
      case "DE":
        licensePlateColor = "#040660";
        fontColor = "#A08346";
        fontColor2 = "#A08346";
        break;
  
      case "FL":
        licensePlateColor = "#FFFFFF";
        fontColor = "#004B2C";
        fontColor2 = "#004B2C";
        break;
  
      case "GA":
        licensePlateColor = "#FFFFFF";
        fontColor = "#000000";
        fontColor2 = "#000000";
        break;
  
      case "HI":
        licensePlateColor = "#FFFFFF";
        fontColor = "#000000";
        fontColor2 = "#000000";
        break;
  
      case "IA":
        licensePlateColor = "#FFFFFF";
        fontColor = "#A6D901";
        fontColor2 = "#19BBCB";
        break;
  
      case "ID":
        licensePlateColor = "#FFFFFF";
        fontColor = "#010101";
        fontColor2 = "#6B0A04";
        break;
  
      case "IL":
        licensePlateColor = "#FFFFFF";
        fontColor = "#E03E38";
        fontColor2 = "#5B98E3";
        break;
  
      case "IN":
        licensePlateColor = "#FFFFFF";
        fontColor = "#2B235B";
        fontColor2 = "#748F62";
        break;
  
      case "KS":
        licensePlateColor = "#61C3F7";
        fontColor = "#18191D";
        fontColor2 = "#18191D";
        break;
  
      case "KY":
        licensePlateColor = "#41A9D0";
        fontColor = "#040660";
        fontColor2 = "#040660";
        break;
  
      case "LA":
        licensePlateColor = "#FFFFFF";
        fontColor = "#022080";
        fontColor2 = "#F71A1A";
        break;
  
      case "MA":
        licensePlateColor = "#FFFFFF";
        fontColor = "#C94035";
        fontColor2 = "#3670E9";
        break;
  
      case "MD":
        licensePlateColor = "#FFFFFF";
        fontColor = "#000000";
        fontColor2 = "#F34E4F";
        break;
  
      case "ME":
        licensePlateColor = "#FFFFFF";
        fontColor = "#000000";
        fontColor2 = "#D34129";
        break;
  
      case "MI":
        licensePlateColor = "#1037A4";
        fontColor = "#FFFFFF";
        fontColor2 = "#FFFFFF";
        break;
  
      case "MN":
        licensePlateColor = "#FFFFFF";
        fontColor = "#000000";
        fontColor2 = "#00CCFF";
        break;
  
      case "MO":
        licensePlateColor = "#FFFFFF";
        fontColor = "#0D004A";
        fontColor2 = "#0D004A";
        break;
  
      case "MS":
        licensePlateColor = "#C5A885";
        fontColor = "#262E46";
        fontColor2 = "#262E46";
        break;
  
      case "MT":
        licensePlateColor = "#29358B";
        fontColor = "#FFFFFF";
        fontColor2 = "#FFFFFF";
        break;
  
      case "NC":
        licensePlateColor = "#FFFFFF";
        fontColor = "#0834AC";
        fontColor2 = "#F22121";
        break;
  
      case "ND":
        licensePlateColor = "#62BDC9";
        fontColor = "#030300";
        fontColor2 = "#ED4D16";
        break;
  
      case "NE":
        licensePlateColor = "#FFFFFF";
        fontColor = "#0A3143";
        fontColor2 = "#B18A3F";
        break;
  
      case "NH":
        licensePlateColor = "#B2C8E4";
        fontColor = "#004322";
        fontColor2 = "#004322";
        break;
  
      case "NJ":
        licensePlateColor = "#FFE86A";
        fontColor = "#000000";
        fontColor2 = "#000000";
        break;
  
      case "NM":
        licensePlateColor = "#05B5DE";
        fontColor = "#D7D710";
        fontColor2 = "#FFFFFE";
        break;
  
      case "NV":
        licensePlateColor = "#80BBF7";
        fontColor = "#09205D";
        fontColor2 = "#B05405";
        break;
  
      case "NY":
        licensePlateColor = "#efb84a";
        fontColor = "#002544";
        fontColor2 = "#002544";
        break;
  
      case "OH":
        licensePlateColor = "#FFFFFF";
        fontColor = "#275F77";
        fontColor2 = "#C63B4B";
        break;
  
      case "OK":
        licensePlateColor = "#51BDD9";
        fontColor = "#0F1D1D";
        fontColor2 = "#0F1D1D";
        break;
  
      case "OR":
        licensePlateColor = "#C0C0D7";
        fontColor = "#322A45";
        fontColor2 = "#322A45";
        break;
  
      case "PA":
        licensePlateColor = "#FFFFFF";
        fontColor = "#112186";
        fontColor2 = "#D4A704";
        break;
  
      case "RI":
        licensePlateColor = "#FFFFFF";
        fontColor = "#2E4290";
        fontColor2 = "#2E4290";
        break;
  
      case "SC":
        licensePlateColor = "#FFFFFF";
        fontColor = "#06205A";
        fontColor2 = "#06205A";
        break;
  
      case "SD":
        licensePlateColor = "#6BDCF3";
        fontColor = "#000000";
        fontColor2 = "#000000";
        break;
  
      case "TN":
        licensePlateColor = "#0D1B4C";
        fontColor = "#FFFFFF";
        fontColor2 = "#FFFFFF";
        break;
  
      case "TX":
        licensePlateColor = "#FFFFFF";
        fontColor = "#000000";
        fontColor2 = "#000000";
        break;
  
      case "UT":
        licensePlateColor = "#9ABDE6";
        fontColor = "#090855";
        fontColor2 = "#B0430F";
        break;
  
      case "VA":
        licensePlateColor = "#FFFFFF";
        fontColor = "#2B3365";
        fontColor2 = "#2B3365";
        break;
  
      case "VT":
        licensePlateColor = "#017E24";
        fontColor = "#FFFFFF";
        fontColor2 = "#FFFFFF";
        break;
  
      case "WA":
        licensePlateColor = "#CDCDD7";
        fontColor = "#04274A";
        fontColor2 = "#C63B5B";
        break;
  
      case "WI":
        licensePlateColor = "#FFFFFF";
        fontColor = "#000000";
        fontColor2 = "#B00F2E";
        break;
  
      case "WV":
        licensePlateColor = "#FFFFFF";
        fontColor = "#1557A7";
        fontColor2 = "#EAA800";
        break;
  
      case "WY":
        licensePlateColor = "#74C9E4";
        fontColor = "#000000";
        fontColor2 = "#AF5600";
        break;
  
      default:
        licensePlateColor = "#000000";
        fontColor = "#FFFFFF";
        fontColor2 = "#FFFFFF";
        break;
    }
  
    return {
      licensePlateColor: licensePlateColor.toLowerCase(),
      fontColor: fontColor.toLowerCase(),
      fontColor2: fontColor2.toLowerCase(),
    };
  }
  
  export default getLicensePlateColor;